export default (function escapeRegExp(text) {
  if (!text) {
    return;
  }
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
});